<template>
  <div ref="containerRef" class="full-width-image">
    <!-- Imagen de fondo -->
    <img
      ref="imagenRef"
      src="@/assets/imagen_2.webp"
      alt="Fondo elegante"
      class="main-image"
    />

   
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'FullWidthImage',
  setup() {
    const containerRef = ref(null)
    const imagenRef = ref(null)
    const svgRef = ref(null)
    const wavePathStroke = ref(null)
    const wavePathFill = ref(null)

    const animate = () => {
      gsap.fromTo(imagenRef.value,
        { scale: 1.1, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1.5, ease: 'power2.out' })

      gsap.fromTo(svgRef.value,
        { y: 50, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.4, ease: 'power3.out', delay: 0.2 })

      const length = wavePathStroke.value.getTotalLength()
      wavePathStroke.value.style.strokeDasharray = length
      wavePathStroke.value.style.strokeDashoffset = length

      gsap.to(wavePathStroke.value, {
        strokeDashoffset: 0,
        duration: 2,
        ease: 'power2.out',
        delay: 0.3
      })

      gsap.to(wavePathFill.value, {
        opacity: 1,
        duration: 1.4,
        ease: 'power2.out',
        delay: 1.2
      })
    }

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate()
          obs.unobserve(entry.target)
        }
      }, { threshold: 0.2 })

      if (containerRef.value) observer.observe(containerRef.value)
    })

    return {
      containerRef,
      imagenRef,
      svgRef,
      wavePathStroke,
      wavePathFill
    }
  }
}
</script>

<style scoped>
.full-width-image {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.main-image {
  width: 100%;
  height: auto;
  display: block;
  transform-origin: center;
  opacity: 0;
}

.animated-wave {
  width: 100%;
  height: auto;
  display: block;
  opacity: 0;
  transform: translateY(50px);
}

.wave-path-stroke {
  fill: none;
  stroke: #f1aeb7a0;
  stroke-width: 3;
}

.wave-path-fill {
  opacity: 0;
  transition: opacity 1s ease;
}
</style>
